const getPlaceholder = placeholder => {
    return placeholder === 'Topic'
        ? 'Subject'
        : placeholder === 'Zip'
        ? 'Postal Code'
        : placeholder === 'Phone'
        ? 'Phone Number'
        : placeholder === 'NamePrefix'
        ? 'Prefix'
        : placeholder === 'Street'
        ? 'Street No & Street'
        : placeholder;
};

const sortOrder = [`Address`, `Street`, `City`, `County`, `Zip`, `Phone`];

export const formElementsLoaded = (state, reps) => {
    return reps
        .filter(rep => rep.bioguideId)
        .every(rep =>
            state.localRep.requiredFormElements.repsUsed.find(r => r === rep.bioguideId)
        );
};

export const requiredFormElements = state => {
    return state.localRep.requiredFormElements.fields
        .filter(
            a =>
                !(
                    a.name === `Street` ||
                    a.name === `City` ||
                    a.name === `County` ||
                    a.name === `Zip`
                )
        )
        .concat({
            type: `Address`,
            name: `Address`
        })
        .map(a => ({
            type: a.type,
            name: a.name,
            index: sortOrder.indexOf(a.name),
            options: a.options,
            defaultOption: 'Choose',
            placeholder: getPlaceholder(a.name)
        }));
};
